import * as React from 'react';
import { ComplexValue } from 'ui';
import { LoadOptions } from 'app/types-shared';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeCodetablePickerProps } from 'app/area/codetable/item/code-pickers/types';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { CodeActionType } from 'app/area/codetable/item/types';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { ScreenField, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { configurationAlreadyExistsKey } from 'app/area/indicator-factors/constants';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';

export const ConsequenceCodeCategory = ({ metadata, codeItem, loadOptions, resetValidation,
  fetchingParentCategory, codeCategoryLabel, options, translation, validation, readOnly, actionType, ...props
}: CodeCodetablePickerProps & {
  codeCategoryLabel?: (translation: CodetableTranslation) => string;
  resetValidation: (key: ScreenPicker | ScreenField | typeof configurationAlreadyExistsKey) => void;
}) => {

  if (!metadata || !metadata.codetableCategory || !isDefinedIncludingZero(metadata.codetableCategory.id)) {
    return null;
  }

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id, metadata.codetableCategory.id, loadOptionsParams);
  };

  const onChange = (value: ComplexValue<number>) => {
    if (validation[configurationAlreadyExistsKey]) {
      validation.recurrence && resetValidation(ScreenPicker.recurrence);
      validation.severity && resetValidation(ScreenPicker.severity);
      validation.likelihood && resetValidation(ScreenPicker.likelihood);
      resetValidation(configurationAlreadyExistsKey);
    }
    props.onChange(value);
  };

  const codeOptions = (!!options.category && options.category.codes || []) as ComplexValue<number>[];

  const categoryValidation = !!validation && !!validation.category ? validation.category : undefined;

  const finalValidation = { 
    ...categoryValidation, 
    ...getDisabledValidation(codeItem.category?.disabled, translation.selected_value_disabled) 
  };

  const isCodeEditing = codeItem && isDefinedIncludingZero(codeItem.id);

  const isCodeDuplicating = actionType === CodeActionType.Duplicate;

  const isCategoryReadOnly = fetchingParentCategory || (!isCodeDuplicating && (isCodeEditing || readOnly));

  return (
    <CodeSinglePicker
      id="category"
      label={metadata.codetableCategory.label ?? (translation && codeCategoryLabel ? codeCategoryLabel(translation) : undefined)}
      valueItem={codeItem && codeItem.category}
      searchRequired={metadata.codetableCategory.id && metadata.codetableCategory.searchRequired}
      required={!isCategoryReadOnly}
      options={codeOptions}
      fetchingOptions={options.category && options.category.fetching}
      showSpinnerLabel={fetchingParentCategory}
      validation={finalValidation}
      translation={translation}
      onLoadOptions={onLoadOptions}
      onChange={onChange}
      readOnly={isCategoryReadOnly}
    />
  );
};
